module.exports = __webpack_public_path__ + "img/home-illustration.7c9c6167.svg";